import { v4 } from 'uuid';
import { getHomeApiUrl } from '../selectors/getBaseUrlSelectors';
import CLIENT_ID_ONLINE from '../constants/rootConstants';

export default {
  fetch: (id, action, state) => ({
    url: `${getHomeApiUrl(state)}/travel/home/v1/tls/benefits`,
    opts: {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        clientId: CLIENT_ID_ONLINE,
        correlation_id: v4(),
      },
    },
  }),
  transformData: (data) => {
    const topCardAccount = data?.accounts?.find((account) => account?.isTopCard);
    return {
      cardType: topCardAccount?.productDetails?.plasticType[0],
      credits: topCardAccount?.offers ? topCardAccount?.offers.map(
        (offer) => ({
          name: offer?.name,
          eligibility: offer?.isEligible,
          total: offer?.offerDetails?.eligibleAmount,
          used: offer?.offerDetails?.usedAmount,
          unused: offer?.offerDetails?.remainingAmount,
        })) : [],
    };
  },
};
